<template>
  <PageTemplate
    :page-name="'forgot-password'"
    :is-loading="false"
  >
    <ForgotPasswordForm v-if="!isRequestSent" />
    <ResendForgotPasswordForm
      v-else
      class="forgot-password__resend-forgot-password"
    />
  </PageTemplate>
</template>

<script>
import { mapGetters } from 'vuex';
import ForgotPasswordForm from './forgot-password-form';
import ResendForgotPasswordForm from './resend-forgot-password-form';
import { PageTemplate } from '@/shared/ui/account';

export default {
  components: { PageTemplate, ForgotPasswordForm, ResendForgotPasswordForm },
  computed: {
    ...mapGetters('resetLinkEmailModule', ['isRequestSent']),
  },
};
</script>

<style lang="scss" scoped>
.forgot-password {
  &__resend-forgot-password {
    box-shadow: 0px 4px 99.8px 0px #73C20082, 0px 0px 13.5px 0px #BAFF5740;
  }
}
</style>
